import { CheckBox, DateBox } from "devextreme-react";
import React from "react";

export default function TwoDateCheckBoxComponent(props) {
  const { firstDateBox, secondDateBox, checkBox, formDataSource } = props;

  return (
    <React.Fragment>
      <DateBox
        ref={firstDateBox.ref}
        placeholder={firstDateBox.placeholder}
        style={{
          float: "left",
          width: "40%",
          marginRight: "3px",
        }}
        displayFormat="yyyy-MM-dd"
        dateSerializationFormat="yyyy-MM-dd"
        showClearButton={true}
        defaultValue={
          formDataSource ? formDataSource[firstDateBox.field] : null
        }
      />
      <DateBox
        ref={secondDateBox.ref}
        placeholder={secondDateBox.placeholder}
        style={{
          float: "left",
          width: "40%",
          marginRight: "3px",
        }}
        displayFormat="yyyy-MM-dd"
        dateSerializationFormat="yyyy-MM-dd"
        showClearButton={true}
        defaultValue={
          formDataSource ? formDataSource[secondDateBox.field] : null
        }
        // disabled={
        //   formDataSource
        //     ? formDataSource[checkBox.field] == true
        //       ? true
        //       : false
        //     : null
        // }
      />
      <CheckBox
        ref={checkBox.ref}
        text={checkBox.text}
        defaultValue={
          formDataSource
            ? formDataSource[checkBox.field] == "1"
              ? true
              : false
            : null
        }
      />
    </React.Fragment>
  );
}
